export default __webpack_public_path__ + "static/media/em-logo-horizontal.38fcd40c.svg";